var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitedKingdomFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1349_25171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.119141H27V20.1191H0V0.119141Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 0.119141L13.4578 7.66081L23.7094 0.119141H27V2.70247L16.875 10.1608L27 17.5775V20.1191H23.625L13.5 12.6608L3.41719 20.1191H0V17.6191L10.0828 10.2025L0 2.78581V0.119141H3.16406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8875 11.8275L27 18.4525V20.1191L15.5672 11.8275H17.8875ZM10.125 12.6608L10.3781 14.1191L2.27813 20.1191H0L10.125 12.6608ZM27 0.119141V0.244141L16.4953 8.07747L16.5797 6.24414L24.8906 0.119141H27ZM0 0.119141L10.0828 7.45247H7.55156L0 1.86914V0.119141Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1672 0.119141V20.1191H16.9172V0.119141H10.1672ZM0 6.78581V13.4525H27V6.78581H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.16081V12.1608H27V8.16081H0ZM11.5172 0.119141V20.1191H15.5672V0.119141H11.5172Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1349_25171"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.119141,
    width: 27,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdomFlag);
export default __webpack_public_path__ + "static/media/united-kingdom-flag.d3eecb6b35a0e88af54992a70c190042.svg";
export { ForwardRef as ReactComponent };